import { IQuestionEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import React, {useEffect, useState, Fragment, CSSProperties} from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import '../listQuestionsExercise.scss'
import shortId from 'shortid';
import AlertComponent from 'app_components/commons/alert';
import { useTranslation } from 'react-i18next';
import { copyObjectEditor } from 'app_utils/functions/editorFunctions';
import { TypeQuestionsCategoriesEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import QuestionsService from 'app_services/editor/questions/questionsService';
import useScroll from 'app_hooks/useScroll';
import QuestionPathItemEditorComponent from '../../questionPathItemEditor/containers/questionPathItemEditorComponent';

interface IStatList{
    name: string
    value: number
    id: string
}

interface IListQuestionsExerciseLayoutProps {
    questions: IQuestionEditor[]
    editState?: boolean
    showStats?: boolean
    hideNewQuestion?: boolean
    hideEditButton?: boolean
    hideViewButton?: boolean
    hideValue?: boolean
    showDelete?: boolean
    idContainerQuestions?: string
    className?: string
    style?: CSSProperties
    onClickQuestion?: (question: IQuestionEditor)=>void
    onReorderQuestions?: (questions: IQuestionEditor[])=>void
    onClickView?: (question: IQuestionEditor)=>void
    onClickDelete?: (question: IQuestionEditor)=>void
    onClickNewQuestion?: (parent: string)=>void
    onChangeQuestions?: (questions: IQuestionEditor[])=>void
    onClickEdit?: (question: IQuestionEditor, parent?: IQuestionEditor)=>void
    onNextPage?: () => any
}

const ListQuestionsExerciseLayout: React.FC<IListQuestionsExerciseLayoutProps> = (props) => {

    const [questions, updateQuestions] = useState<IQuestionEditor[]>([])
    const [stats, updateStats] = useState<IStatList[]>([])
    const {t} = useTranslation()

    // Servicios
    const questionsService = new QuestionsService()

    useEffect(() => {
        if(props.questions && props.questions.length){
            const newQuestions = validateValueQuestions(copyObjectEditor(props.questions))
            updateQuestions(copyObjectEditor(newQuestions))
        }else{
            updateQuestions([])
        }
    },[props.questions, props.editState])

    useEffect(() => {
        getStats()
    }, [questions])

    /**
     * @INFO Validar el valor de las preguntas, debe ser 1
     */
    const validateValueQuestions = (_questions: IQuestionEditor[]) => {
      let response: IQuestionEditor[] = []
      if(_questions && _questions.length){
        response = _questions.reduce((acum: IQuestionEditor[], itemQuestion) => {
          const newQuestion = {...itemQuestion}
          newQuestion.value = 1
          if(newQuestion.childs && newQuestion.childs.length){
            newQuestion.childs.forEach((child, idxChild) => {
              // @ts-ignore
              newQuestion.childs[idxChild].value = 1
            })
          }
          acum.push(newQuestion)
          return acum
        }, [])
      }
      return response
    }

    /**
     * @INFO Referencia para el click en una pregunta
     * @param question
     */
    const handleClickQuestion = async (question: IQuestionEditor) => {
        if(props.onClickQuestion ){
          const status = await questionsService.validateChangeQuestion()
          if(status){
            props.onClickQuestion(question)
          }
        }
    }

    /**
     * @INFO Referencia para el click en ver una pregunta
     * @param question
     */
    const handleClickView = (question: IQuestionEditor) => {
        if(props.onClickView ){
            props.onClickView(question)
        }
    }

    /**
     * @INFO Referencia para el click en editar una pregunta
     * @param question
     */
    const handleClickEdit = (question: IQuestionEditor, _parent?: IQuestionEditor) => {
        let parent = undefined
        if(_parent && _parent.question?.question_category?.name === 'container'){
          parent = {..._parent}
        }
        if(props.onClickEdit ){
            props.onClickEdit(question, parent)
        }
    }

    /**
     * @INFO Referencia de click en eliminar pregunta
     * @param question
     */
    const handleClickDelete = (question: IQuestionEditor) => {
        if(props.onClickDelete){
            props.onClickDelete(question)
        }
    }

    /**
     * @INFO Referencia para crear nueva pregunta de un estimulo
     * @param parent
     */
    const handleClickNewQuestion = (parent?: string) => {
        if(parent){
            if(props.onClickNewQuestion){
                props.onClickNewQuestion(parent)
            }
        }
    }

    /**
     * @INFO Referencia de cambio de valor en preguntas
     * @param e
     * @param idxQuestion
     */
    const handleChangeValueQuestion = (e: any, idxQuestion: number, idxParent?: number) => {
        const questionsAux = [...questions]
        if(idxParent !== undefined){
            if(questionsAux[idxParent].childs !== undefined){
                // @ts-ignore
                questionsAux[idxParent].childs[idxQuestion].value = Number(e.target.value)
            }
        }else{
            questionsAux[idxQuestion].value = Number(e.target.value)
        }
        updateQuestions(questionsAux)
        if(props.onChangeQuestions){
            props.onChangeQuestions(questionsAux)
        }
    }

    /**
     * @INFO Referencia para reordenar preguntas
     * @param result
     */
    const handleReorderQuestions = async (result: any) => {
        if(!result.destination) return
        const status = await questionsService.validateChangeQuestion()
        if(!status) return
        const questionsAux = [...questions]
        const startIndex = result.source.index
        const endIndex = result.destination.index
        const [removed] = questionsAux.splice(startIndex, 1)
        questionsAux.splice(endIndex, 0, removed)
        if(props.onReorderQuestions){
            props.onReorderQuestions(questionsAux)
        }
        updateQuestions(questionsAux)
    }

    /**
     * @INFO Referencia para reordenar hijos de una pregunta
     * @param result
     * @param idQuestion
     */
    const handleReorderChilds = async (result: any, idQuestion: string) => {
        if(!result.destination) return
        const status = await questionsService.validateChangeQuestion()
        if(!status) return
        const questionsAux = [...questions]
        const startIndex = result.source.index
        const endIndex = result.destination.index
        // Encontrar la pregunta
        const idxQuestion = questionsAux.findIndex((item) => item.question._id === idQuestion)
        if(idxQuestion >= 0){
            if(questionsAux[idxQuestion].childs){
                // @ts-ignore
                const [removed] = questionsAux[idxQuestion].childs?.splice(startIndex, 1)
                questionsAux[idxQuestion].childs?.splice(endIndex, 0, removed)
                if(props.onReorderQuestions){
                    props.onReorderQuestions(questionsAux)
                }
                updateQuestions(questionsAux)
            }
        }
    }

    /**
     * @INFO Obtener stats de preguntas
     */
    const getStats = () => {
        if(questions && questions.length){
            const arrayAux: TypeQuestionsCategoriesEditor[] = ['container', 'select-range', 'multiple-choice-multiple-answer', 'multiple-choice-unique-answer', 'open-answer']
            let statsAux: IStatList[] = []
            statsAux.push({
                name: 'Cantidad de preguntas',
                value: questions.length,
                id: shortId.generate()
            })
            arrayAux.forEach((item) => {
                const aux = filterQuestionsFromType(item)
                if(aux && aux.length){
                    statsAux.push({
                        name: aux.name,
                        value: aux.length,
                        id: shortId.generate()
                    })
                }
            })
            updateStats([...statsAux])
        }
    }

    /**
     * @INFO Filtrar las preguntas sun el tipo
     * @param type
     */
    const filterQuestionsFromType = (type: TypeQuestionsCategoriesEditor) => {
        let nameCategory: string = ''
        const descriptionsQuestions: string[] = questions.reduce((acum: string[], item) => {
            if(item.question.question_category.name === type){
                acum.push(item.question.question_category.description)
                nameCategory = item.question.question_category.description
            }
            return acum
        },[])
        if(descriptionsQuestions.length){
            return {
                length: descriptionsQuestions.length,
                name: nameCategory
            }
        }else{
            return undefined
        }
    }

    /**
     * @INFO Obtener el valor para las preguntas tipo estimulo
     * @param idQuestion
     */
    const getValueContainerQuestion = (idQuestion: string) => {
        const aux = [...questions]
        const idxQuestion = aux.findIndex(item => item.question._id === idQuestion)
        if(idxQuestion >= 0){
            let result: undefined | number = undefined
            if(aux[idxQuestion].childs){
                result = aux[idxQuestion].childs?.reduce((acum: number | undefined, item) => {
                    if(acum === undefined){
                        acum = item.value
                    }else{
                        acum += item.value
                    }
                    return acum
                }, undefined)
            }
            return result
        }
        return undefined
    }

    /**
     * @INFO Crear las funciones de scroll del contenedor de preguntas
     */
    const handleGetNextPage = () => {
      if(props.onNextPage){
        props.onNextPage()
      }
    }
    if(props.idContainerQuestions){
      const {reconnectScroll} = useScroll(props.idContainerQuestions, handleGetNextPage)
    }

    return (
        <div
          className={`list_questions_exercise-component ${props.className ? props.className : ''}`}
          style={props.style}
        >
            {props.showStats ?
                <div className="stats-container">
                    {stats.map(item => (
                        <Fragment key={item.id}>
                            <p>{item.name}:</p>
                            <p>{item.value}</p>
                        </Fragment>
                    ))}
                </div>
            :null}
            <div
              className='container-questions-list'
              id={props.idContainerQuestions}
            >
              {questions && questions.length ?
                  <DragDropContext onDragEnd={handleReorderQuestions} >
                      <Droppable droppableId='drag_drop_list_questions_exercise' >
                          {(provided, snapshot) => (
                              <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                  id='questions_list_component'
                              >
                                  {questions.map((itemQuestion: IQuestionEditor, idxQuestion) => (
                                      <QuestionPathItemEditorComponent
                                          key={itemQuestion.question._id}
                                          editState={props.editState !== undefined ? props.editState : false}
                                          question={itemQuestion}
                                          index={idxQuestion}
                                          showActions
                                          dragDisabled={!props.editState}
                                          hideNewQuestion={props.hideNewQuestion}
                                          hideEditButton={props.hideEditButton}
                                          hideViewButton={props.hideViewButton}
                                          hideValue={props.hideValue}
                                          showDelete={props.showDelete}
                                          valueQuestion={getValueContainerQuestion(itemQuestion.question._id)}
                                          onClick={()=>handleClickQuestion(itemQuestion)}
                                          onReorderChilds={(result)=>handleReorderChilds(result, itemQuestion.question._id)}
                                          onClickView={()=>handleClickView(itemQuestion)}
                                          onClickDelete={()=>handleClickDelete(itemQuestion)}
                                          onClickNewAnswer={handleClickNewQuestion}
                                          onChangeValue={(e)=>handleChangeValueQuestion(e, idxQuestion)}
                                          onClickEdit={()=>handleClickEdit(itemQuestion, itemQuestion)}
                                      >
                                          {itemQuestion.childs ?
                                              itemQuestion.childs.map((itemChildQuestion, idxChildQuestion) => (
                                                  <QuestionPathItemEditorComponent
                                                      index={idxChildQuestion}
                                                      key={itemChildQuestion.question._id}
                                                      editState={props.editState !== undefined ? props.editState : false}
                                                      showActions
                                                      dragDisabled={!props.editState}
                                                      question={itemChildQuestion}
                                                      hideNewQuestion={props.hideNewQuestion}
                                                      hideEditButton={props.hideEditButton}
                                                      hideViewButton={props.hideViewButton}
                                                      hideValue={props.hideValue}
                                                      showDelete={props.showDelete}
                                                      onClick={()=>handleClickQuestion(itemChildQuestion)}
                                                      onClickView={()=>handleClickView(itemChildQuestion)}
                                                      onClickDelete={()=>handleClickDelete(itemChildQuestion)}
                                                      onChangeValue={(e)=>handleChangeValueQuestion(e, idxChildQuestion, idxQuestion)}
                                                      onClickEdit={()=>handleClickEdit(itemChildQuestion, itemQuestion)}
                                                  />
                                              ))
                                          : null}
                                      </QuestionPathItemEditorComponent>
                                  ))}
                                  {provided.placeholder}
                              </div>
                          )}
                      </Droppable>
                  </DragDropContext>
              : <AlertComponent title={t('editor.resources.exercise.not_selected')} type='info' /> }
            </div>
        </div>
    );
};

export default ListQuestionsExerciseLayout;
